export const IMPORT_SET_FILE = 'IMPORT_SET_FILE';
export const IMPORT_REMOVE_FILE = 'IMPORT_REMOVE_FILE';
export const IMPORT_UPLOAD_FILE = 'IMPORT_UPLOAD_FILE';
export const IMPORT_PROGRESS_FILE = 'IMPORT_PROGRESS_FILE';
export const IMPORT_PROCESS_FILE = 'IMPORT_PROCESS_FILE';
export const IMPORT_FILE = 'IMPORT_FILE';
export const SET_IMPORT_FILTERS = 'SET_IMPORT_FILTERS';
export const MODIFY_EDITING_IMPORT = 'MODIFY_EDITING_IMPORT';
export const SET_IMPORT_PAGINATION = 'SET_IMPORT_PAGINATION';
export const GET_IMPORT_RECORDS = 'GET_IMPORT_RECORDS';
export const RESET_IMPORT = 'RESET_IMPORT';

export const headers = {
  assets: [
    'numero',
    'numero_de_serie',
    'nombre',
    'modelo',
    'marca',
    'estado_fisico_clave',
    'estado_fisico_valor',
    'fecha_de_compra',
    'pais_clave',
    'pais_valor',
    'descripcion',
    'responsable_clave',
    'responsable_nombre',
    'ubicacion',
    'proveedor_clave',
    'proveedor_nombre',
    'precio',
    'moneda_clave',
    'moneda_valor',
    'precio_usd',
    'tipo_de_cambio',
    'condicion_de_compra_clave',
    'condicion_de_compra_valor',
    'centro_de_costo_clave',
    'centro_de_costo_valor',
    'cuenta_clave',
    'cuenta_nombre',
    'tipo_clave',
    'tipo_nombre',
    'fecha_de_aplicacion',
    'estatus_depreciacion_clave',
    'depreciacion_financiera_clave',
    'depreciacion_financiera_nombre',
    'depreciacion_fiscal_clave',
    'depreciacion_fiscal_nombre',
    'vida_util_original',
    'proyecto_clave',
    'proyecto_nombre',
    'proyecto_costo',
    'proyecto_numero_de_aprobacion',
    'orden_de_compra',
    'asegurable',
    'asegurable_clave',
    'asegurable_nombre',
    'poliza_de_seguro',
    'porcentaje_asegurado',
    'numero_de_factura',
    'folio_de_factura',
    'fecha_de_factura',
    'concepto_de_factura',
    // Right after the invoice columns, as in the assets report. The import maps
    // by header name (lib/import/map_import_headers.js), so files with the column
    // at the end (template of 2026-10-30) or without it (older) still import.
    'referencia_dms',
    'fecha_de_baja',
    'motivo_de_baja_clave',
    'motivo_de_baja_valor',
    'detalle_de_baja',
    'cantidad_de_baja',
    'numero_de_pedimento',
    'clave_de_pedimento',
    'clave_de_aduana',
    'fecha_de_pedimento',
    'estatus_de_pedimento_clave',
    'importe_de_pedimento',
    'cantidad_de_items_en_pedimento'
  ],
  providers: ['clave', 'nombre', 'correo', 'telefono', 'rfc'],
  projects: ['clave', 'nombre', 'importe'],
  cost_centers: ['clave', 'nombre', 'descripcion'],
  cuenta_contable: ['clave', 'nombre', 'descripcion'],
  tipo_activo: ['clave', 'nombre', 'cuenta_contable_clave', 'descripcion'],
  custom_employees: ['clave', 'nombre'],
  employees: ['clave', 'nombre', 'apellido', 'correo', 'posicion'],
  locations: ['nombre', 'padre'],
};



// WEBPACK FOOTER //
// src/modules/secured/modules/import/constants/import_constants.js